import { Injectable } from '@angular/core';
import { NbSidebarService } from '@nebular/theme';

import { LayoutService } from '../../../@core/data/layout.service';
import { AuthService } from '../security/auth.service';

@Injectable()
export class SidebarManagerService {

  constructor(private readonly sidebarService: NbSidebarService,
              private readonly layoutService: LayoutService,
              private readonly authService: AuthService) {

  }

  toggle(): void {
    if (this.authService.getUser()) {
      const sideBarElement = document.getElementById('sidebarId');
      if (sideBarElement) {
        const classList = sideBarElement.classList;
        if (classList.contains('expanded') || (!classList.contains('compacted') && !classList.contains('collapsed'))) {
          this.sidebarService.toggle(true, 'menu-sidebar');
          this.layoutService.changeLayoutSize();
        }
      }
    }
  }

}
